import dayjs from 'dayjs'
import { ISO_EXTENDED } from './formats'

const BASE_DATE = dayjs().startOf('day')

export const YEAR_BOUND = 125
export const MIN_DATE = BASE_DATE.subtract(YEAR_BOUND, 'y').format(ISO_EXTENDED)
export const MAX_DATE = BASE_DATE.add(YEAR_BOUND, 'y').format(ISO_EXTENDED)
